const css = require('sheetify')

module.exports = css`
  @import url("https://unpkg.com/purecss@1.0.1/build/pure-min.css");

  body {
    margin: 0 auto;
    width: 60vw;
  }

  #calc #title {
    text-align: center;
  }

  #calc #years {
    text-align: center;
  }

  #calc #years li {
    margin: 0 0.5em 0 0
  }

  #calc #years .pure-menu-selected {
    text-decoration: underline;
  }

  #calc .year {
    display: none;
  }

  #calc .year.year-active {
    display: block;
  }

  #calc header, #calc footer {
    margin: 1em 0;
    /* overflow: hidden; */
  }

  #calc .semesters {
    clear: both;
  }

  #calc .semester {
    text-align: left;
  }

  /* #calc .semester {
    overflow-x: auto;
  } */

  .x-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  #calc .courses {
    width: 100%;
    margin: 1em 0;
    text-align: center;
  }

  #calc .course-name input, #calc .course-weight select {
    width: 100%;
  }

  #calc .course-credits input {
    width: 3em;
  }

  #calc .year-tools, #calc .semester-tools {
    text-align: left;
    float: left;
  }

  #calc .year-tools button, #calc .semester-tools button {
    margin: 0 1em 0 0;
  }

  #calc #base-credits {
    margin: 0 1em 1em 0;
    float: left;
    text-align: left;
  }

  #calc #cumulative-gpa, #calc #total-credits {
    float: right;
    text-align: right;
    margin: 0 auto;
  }

  #calc #total-credits {
    clear: right;
  }

  #calc #base-credits input {
    width: 2em;
    margin: 0 0.25em;
  }

  #calc .year-gpa, #calc .semester-gpa {
    float: right;
    text-align: right;
  }

  #calc h2 button, #calc h3 button {
    float: right;
    font-size: 14px;
    font-weight: normal;
  }

  #calc .year-gpa h2, #calc .year-gpa h3, #calc .year-gpa h4, #calc .semester-gpa h2, #calc .semester-gpa h3, #calc .semester-gpa h4 {
    margin: 0;
  }

  #calc .year > header, #calc .year > footer, #calc .semester > footer {
    overflow: hidden;
    width: 100%;
  }

  #calc .year > header {
    /* padding: 0 0 1.5em 0;
    margin: 0 0 1.5em 0; */
    border-bottom: 1px solid #ddd;
  }

  #calc .year > footer {
    padding: 1.5em 0;
    margin: 1.5em 0;
    border-top: 1px solid #ddd;
  }

  @media screen and (max-width: 700px) {
    .semester-gpa {
      margin-top: 1em;
    }
    .year-gpa {
      margin-bottom: 1em;
    }
  }


  @media print {
    #calc {
      width: 100%;
    }

    /* #calc header h1 {
      display: none;
    } */

    #calc .year {
      display: block;
    }

    #calc input {
      border: none;
    }

    .courses td:last-child {
      display: none;
    }

    #calc button {
      display: none;
    }

    #calc .no-base-credits {
      display: none;
    }

    #calc #add-course table {
      margin-top: 0;
    }

    #calc thead {
      font-weight: bold;
    }

    #calc select {
      border: none;
      -moz-appearance: none;
      -webkit-appearance: none;
    }

    #calc select::-ms-expand {
      display: none;
    }
  }
`
